var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcDownload(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.2358 7.32667C15.2875 4.80083 12.8575 3 10 3C6.57333 3 3.75333 5.58667 3.37917 8.9125C1.455 9.28167 0 10.9683 0 13C0 15.3008 1.86583 17.1667 4.16667 17.1667H15C17.7617 17.1667 20 14.9283 20 12.1667C20 9.8325 18.3983 7.87833 16.2358 7.32667Z",
    fill: "#DBDBDB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.25502 11.3333C6.74252 11.3333 6.48502 11.9516 6.84585 12.3149L9.40835 14.9016C9.73419 15.2308 10.2667 15.2308 10.5925 14.9016L13.155 12.3149C13.515 11.9516 13.2567 11.3333 12.745 11.3333H7.25502Z",
    fill: "#474B53"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.16675 12.1667V8.00008C9.16675 7.54008 9.54008 7.16675 10.0001 7.16675C10.4601 7.16675 10.8334 7.54008 10.8334 8.00008V12.1667C10.8334 12.6267 10.4601 13.0001 10.0001 13.0001C9.54008 13.0001 9.16675 12.6267 9.16675 12.1667Z",
    fill: "#474B53"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcDownload);
export default __webpack_public_path__ + "static/media/ic-download.c1e1b3d555b0847650f6be112d570c3b.svg";
export { ForwardRef as ReactComponent };